export const validateAllPropertyTotals = (formData: any, form: any) => {
    // Property types to validate
    const propertyTypes = [
      {
        type: "appartements",
        pricesField: "appartements_prices",
        totalField: "nbr_unites_appartements",
        soldField: "nbr_unites_appartements_vendues",
        unsoldField: "nbr_unites_appartements_invendues",
        displayName: "Appartements"
      },
      {
        type: "villas",
        pricesField: "villas_prices",
        totalField: "nbr_unites_villas",
        soldField: "nbr_unites_villas_vendues",
        unsoldField: "nbr_unites_villas_invendues",
        displayName: "Villas"
      },
      {
        type: "bureaux",
        pricesField: "bureaux_prices",
        totalField: "nbr_unites_bureaux",
        soldField: "nbr_unites_bureaux_vendues",
        unsoldField: "nbr_unites_bureaux_invendues",
        displayName: "Bureaux"
      },
      {
        type: "locaux_commerciaux",
        pricesField: "locaux_commerciaux_prices",
        totalField: "nbr_unites_lc",
        soldField: "nbr_unites_lc_vendues",
        unsoldField: "nbr_unites_lc_invendues",
        displayName: "Locaux Commerciaux"
      }
    ];
  
    // Array to collect all error messages
    const errors = [];
  
    // Check each property type
    for (const property of propertyTypes) {
      // Skip if this property type isn't used in the form
      if (!formData[property.type] || formData[property.type].length === 0) {
        continue;
      }
      
      const pricesList = form.getFieldValue(property.pricesField) || [];
      
      // Calculate totals from price list
      const totalInPrices = pricesList.reduce(
        (sum:any, item:any) => sum + (item.nbr_unites_total || 0),
        0
      );
      
      // Get the declared total from form data
      const totalDeclared = formData[property.totalField] || 0;
      
      // Validate total units
      if (totalInPrices !== totalDeclared) {
        errors.push(`${property.displayName}: Le nombre total d'unités dans la programmation (${totalInPrices}) ne correspond pas au nombre total déclaré (${totalDeclared}).`);
      }
      
      // Validate sold units
      const totalSoldInPrices = pricesList.reduce(
        (sum:any, item:any) => sum + (item.nbr_unites_vendues || 0),
        0
      );
      
      const totalSoldDeclared = formData[property.soldField] || 0;
      
      if (totalSoldInPrices !== totalSoldDeclared) {
        errors.push(`${property.displayName}: Le nombre total d'unités vendues dans la programmation (${totalSoldInPrices}) ne correspond pas au nombre total déclaré (${totalSoldDeclared}).`);
      }
      
      // Validate unsold units
      const totalUnsoldInPrices = pricesList.reduce(
        (sum:any, item:any) => sum + (item.nbr_unites_invendues || 0),
        0
      );
      
      const totalUnsoldDeclared = formData[property.unsoldField] || 0;
      
      if (totalUnsoldInPrices !== totalUnsoldDeclared) {
        errors.push(`${property.displayName}: Le nombre total d'unités invendues dans la programmation (${totalUnsoldInPrices}) ne correspond pas au nombre total déclaré (${totalUnsoldDeclared}).`);
      }
      
      // Check if each item's total equals its sold + unsold
      for (const item of pricesList) {
        const total = item.nbr_unites_total || 0;
        const sold = item.nbr_unites_vendues || 0;
        const unsold = item.nbr_unites_invendues || 0;
        
        if (total !== (sold + unsold)) {
          errors.push(`${property.displayName}: Pour le type "${item.name || 'N/A'}", le total (${total}) ne correspond pas à la somme des unités vendues (${sold}) et invendues (${unsold}).`);
        }
      }
    }
    
    // Return results
    return {
      isValid: errors.length === 0,
      errors: errors
    };
  };